import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "transcribe_job_name", label: "transcribe_job_name" },
    { key: "diarization_status", label: "diarization_status" },
    { key: "processing_time_ms", label: "processing_time_s", transform: "secondsFromMs" }
  ],
};

export default schema;

